import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import classes from './myLearning.module.css';
import Header from '../../components/standartComponents/header';
import { useTranslation } from 'react-i18next';

const INITIAL_VIDEOS = {
  progress: [
    { id: 1, title: 'Airport Announcement-3', topic: 'Подорожі', level: 'B1', progress: 60, words: 12, fav: true, thumbBg: 'linear-gradient(135deg, #0F0B2E, #1A1145, #2D1B69)' },
    { id: 2, title: 'Coffee Shop Dialogue', topic: 'Повсякденне життя', level: 'A1', progress: 35, words: 8, fav: false, thumbBg: 'linear-gradient(135deg, #1A1145, #2D1B69, #3B2082)' },
    { id: 3, title: 'Hotel Reception', topic: 'Подорожі', level: 'A2', progress: 80, words: 15, fav: true, thumbBg: 'linear-gradient(135deg, #2D1B69, #0F0B2E, #1A1145)' }
  ],
  completed: [
    { id: 4, title: 'Taxi Ride', topic: 'Подорожі', level: 'A1', progress: 100, words: 10, fav: false, thumbBg: 'linear-gradient(135deg, #0F0B2E, #2D1B69)' },
    { id: 5, title: 'Job Interview Basics', topic: 'Робота', level: 'A2', progress: 100, words: 18, fav: true, thumbBg: 'linear-gradient(135deg, #1A1145, #0F0B2E)' }
  ]
};

const MyLearning = ({ authUser }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [videoTab, setVideoTab] = useState('progress');
  const [videosData, setVideosData] = useState(INITIAL_VIDEOS);

  const getFavorites = () => [...videosData.progress, ...videosData.completed].filter(v => v.fav);

  const toggleFav = (id) => {
    setVideosData(prev => {
      const p = prev.progress.map(v => v.id === id ? { ...v, fav: !v.fav } : v);
      const c = prev.completed.map(v => v.id === id ? { ...v, fav: !v.fav } : v);
      return { progress: p, completed: c };
    });
  };

  const currentVideos = videoTab === 'progress' ? videosData.progress 
    : videoTab === 'completed' ? videosData.completed 
    : getFavorites();

  const handleRemoveVideo = (id) => {
    setVideosData(prev => ({
      progress: prev.progress.filter(v => v.id !== id),
      completed: prev.completed.filter(v => v.id !== id)
    }));
  };

  return (
    <>
      <Header authUser={authUser} />
      
      <div className={classes.page}>
        {/* WELCOME */}
        <div className={classes.welcome}>
          <h1>З поверненням, {authUser?.name || 'Аліно'}! 👋</h1>
          <p>Продовжуйте самостійне навчання з того місця, де зупинилися.</p>
        </div>

        {/* CONTINUE */}
        <div className={classes.cont}>
          <div className={classes.contLeft}>
            <div className={classes.contIcon}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="5 3 19 12 5 21 5 3"/></svg>
            </div>
            <div>
              <div className={classes.contLabel}>Продовжити навчання</div>
              <div className={classes.contTitle}>Coffee Shop Dialogue</div>
              <div className={classes.contStep}>Зупинилися на кроці: Words · 35% пройдено</div>
            </div>
          </div>
          <div className={classes.contRight}>
            <button className={`${classes.contBtn} ${classes.cbP}`} onClick={() => navigate('/lesson/1')}>
              Продовжити <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
            </button>
            <button className={`${classes.contBtn} ${classes.cbS}`} onClick={() => navigate('/allvideos')}>Усі відео</button>
          </div>
        </div>

        {/* STATS */}
        <div className={classes.stats}>
          <div className={classes.stat}>
            <div className={`${classes.statIcon} ${classes.si1}`}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="5 3 19 12 5 21 5 3"/></svg>
            </div>
            <div className={classes.statVal}>{videosData.progress.length}</div>
            <div className={classes.statLbl}>відео в процесі</div>
          </div>
          <div className={classes.stat}>
            <div className={`${classes.statIcon} ${classes.si2}`}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
            </div>
            <div className={classes.statVal}>{videosData.completed.length}</div>
            <div className={classes.statLbl}>відео завершено</div>
          </div>
          <div className={classes.stat}>
            <div className={`${classes.statIcon} ${classes.si3}`}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z"/></svg>
            </div>
            <div className={classes.statVal}>42</div>
            <div className={classes.statLbl}>слова у словнику</div>
          </div>
          <div className={classes.stat}>
            <div className={`${classes.statIcon} ${classes.si4}`}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"/></svg>
            </div>
            <div className={classes.statVal}>7</div>
            <div className={classes.statLbl}>днів підряд</div>
          </div>
        </div>

        {/* COURSES SECTION */}
        <div className={classes.sec}>
          <div className={classes.secHead}>
            <div className={classes.secTitle}>Мої курси</div>
          </div>
          <div className={classes.secSub}>Персональні навчальні плани з прогресом по рівню.</div>
          
          <div className={classes.courseRec} style={{gridTemplateColumns: '1fr'}}>
            <div className={classes.crCard} onClick={() => navigate('/create-course')} style={{maxWidth: '380px'}}>
              <div className={classes.crBadge}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m12 3-1.9 5.8a2 2 0 0 1-1.3 1.3L3 12l5.8 1.9a2 2 0 0 1 1.3 1.3L12 21l1.9-5.8a2 2 0 0 1 1.3-1.3L21 12l-5.8-1.9a2 2 0 0 1-1.3-1.3L12 3Z"/></svg>Рекомендовано
              </div>
              <div className={classes.crIcon}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>
              </div>
              <div className={classes.crTitle}>Хочете більше структури?</div>
              <div className={classes.crDesc}>Персональний план допоможе проходити уроки у правильному порядку та бачити прогрес по рівню.</div>
              <button className={`${classes.crBtn} ${classes.crBtnP}`} onClick={(e) => { e.stopPropagation(); navigate('/create-course'); }}>
                Створити план <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
              </button>
              <div className={classes.crNote}>Самостійне навчання залишиться доступним.</div>
            </div>
          </div>
        </div>

        {/* MY VIDEOS */}
        <div className={classes.sec}>
          <div className={classes.secHead}>
            <div className={classes.secTitle}>Мої відео</div>
            <Link to="/allvideos" className={classes.secLink}>Перейти до всіх відео <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg></Link>
          </div>
          <div className={classes.secSub}>Відео, які ви почали, завершили або зберегли.</div>

          <div className={classes.vtabs}>
            <button className={`${classes.vtab} ${videoTab === 'progress' ? classes.on : ''}`} onClick={() => setVideoTab('progress')}>
              У процесі <span className={classes.vtabCount}>{videosData.progress.length}</span>
            </button>
            <button className={`${classes.vtab} ${videoTab === 'completed' ? classes.on : ''}`} onClick={() => setVideoTab('completed')}>
              Завершені <span className={classes.vtabCount}>{videosData.completed.length}</span>
            </button>
            <button className={`${classes.vtab} ${videoTab === 'favorites' ? classes.on : ''}`} onClick={() => setVideoTab('favorites')}>
              Вибрані <span className={classes.vtabCount}>{getFavorites().length}</span>
            </button>
          </div>

          <div className={classes.vgrid}>
            {currentVideos.map(v => {
              const isDone = v.progress === 100;
              return (
                <div key={v.id} className={classes.vc} onClick={() => navigate(`/lesson/${v.id}`)}>
                  <div className={classes.vcThumb} style={{background: v.thumbBg}}>
                    <div className={classes.vcLevel}>{v.level}</div>
                    <button className={`${classes.vcFav} ${v.fav ? classes.on : ''}`} onClick={(e) => { e.stopPropagation(); toggleFav(v.id); }}>
                      <svg viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
                    </button>
                    <div className={classes.vcTopic}>{v.topic}</div>
                  </div>
                  <div className={classes.vcBody}>
                    <div className={classes.vcTitle}>{v.title}</div>
                    <div className={classes.vcMeta}>
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>{v.progress}%
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{marginLeft: '8px'}}><path d="m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z"/></svg>{v.words} слів
                    </div>
                    <div className={classes.vcBar}>
                      <div className={`${classes.vcBarFill} ${isDone ? classes.done : classes.prog}`} style={{width: `${v.progress}%`}}></div>
                    </div>
                    <div className={classes.vcBottom}>
                      <span className={`${classes.vcPct} ${isDone ? classes.done : ''}`}>{isDone ? 'Завершено ✓' : `${v.progress}%`}</span>
                      <button className={classes.vcRemove} onClick={(e) => { e.stopPropagation(); handleRemoveVideo(v.id); }}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

      </div>
    </>
  );
};

export default MyLearning;
